// extracted by mini-css-extract-plugin
module.exports = {"rowDescription":"styles_rowDescription__bh363","secondaryList":"styles_secondaryList__aNOZA","title":"styles_title___v4SM","desc":"styles_desc__Eu8Ct"};